import $ from 'jquery';
import Promise from 'promise-polyfill';
import radio from 'radio';
import componentLoader from 'shared/utils/component-loader';
import { PAGE_READY } from 'shared/enums/events';
import eventHandlers from './event-handlers';
import segment from './utils/segment';
import addBodyClasses from './utils/body-classes';
import banner from './utils/notification-banner';
const rootUrl = `${window.location.protocol}//${window.location.host}`;
const serviceWorkerURL = `${rootUrl}/sw.js`;

// Add a Promise polyfill for unsupported browsers.
if (!window.Promise) {
  window.Promise = Promise;
}

// Add jQuery and TimeInc namespace to the global scope.
window.$ = $;
window.jQuery = $;
window.TimeInc = window.TimeInc || {};

$(() => {
  // Set this so that by default $.getScript will not append
  // timestamps to script src requests.
  $.ajaxSetup({ cache: true });

  // Register global event handlers.
  eventHandlers();

  // Activate components.
  componentLoader.load();

  // Let the application know the page is ready.
  radio(PAGE_READY).broadcast();

  // Register service worker.
  if (navigator.serviceWorker) {
    navigator.serviceWorker.register(serviceWorkerURL, { scope: rootUrl });
  }

  // Load utility scripts.
  [segment, banner].map(util => util.load());
  addBodyClasses();
});



// WEBPACK FOOTER //
// ./~/unicorn/public/src/main.js
